import { renderToast, toast } from "components/UI/ToastNotification";
import { ADDON_STATUS_CODE, SERVICE_CONSTANTS } from "constants/service";
import { USER_ROLE } from "constants/warehouseDeliveryOptions";
import { navigate } from "hooks/useHookRouterCompat";
import { useAPI } from "lib/API";
import { getItems } from "lib/SessionStorage";
import { createService, updateService } from "requests/services";
import { STORAGE_KEYS } from 'constants/general';

const getToastMessageByStatus = (status: string) => {
    switch (status) {
        case ADDON_STATUS_CODE.DRAFT:
            return SERVICE_CONSTANTS.SERVICE_DRAFTED;
        case ADDON_STATUS_CODE.PUBLISHED:
            return SERVICE_CONSTANTS.SERVICE_PUBLISHED;
        case ADDON_STATUS_CODE.UNPUBLISHED:
            return SERVICE_CONSTANTS.SERVICE_UNPUBLISHED;
        default:
            return SERVICE_CONSTANTS.SERVICE_DRAFTED;
    }
}

export const useServiceRequest = () => {

    const createServiceReq = useAPI({
        deferFn: createService,
        onResolve: (result) => {
            const { data } = result;
            const { serviceStatus: { code } } = data;
            renderToast(toast.TYPE.SUCCESS, getToastMessageByStatus(code));
            navigate('/addons');
        },
        onReject: err => {
            renderToast(toast.TYPE.ERROR, err.message);
        }
    });

    const updateServiceReq = useAPI({
        deferFn: updateService,
        onResolve: (result) => {
            const { data } = result;
            const { serviceStatus: { code } } = data;
            const userRole = getItems(STORAGE_KEYS.AUTH)?.user?.role;
            userRole !== USER_ROLE.Vendor ? renderToast(toast.TYPE.SUCCESS, getToastMessageByStatus(code)) : renderToast(toast.TYPE.SUCCESS, SERVICE_CONSTANTS.SERVICE_DRAFTED);
            navigate('/addons');
        },
        onReject: err => {
            renderToast(toast.TYPE.ERROR, err.message);
        }
    });

    return {
        createServiceReq,
        updateServiceReq
    }
}